import React, { Component } from 'react';
import { connect } from "react-redux";
import { updateSelectedOrder, updateActiveDeliveryOrder, clearActiveDeliveryOrder, clearSelectedOrder } from '../../data/actions/orders';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMotorcycle, faEye, faPizzaSlice } from '@fortawesome/free-solid-svg-icons'


import time from '../../../script/utils/time';
import './orders-list.css';
import { i18n_get_value, I18N_LABELS } from '../../../i18n/i18n_scripts';
import PizzaIcon from '../../../assets/icons/pizza.svg';
import ChefIcon from '../../../assets/icons/chef.svg';

// Initialize font awesome
library.add(faMotorcycle, faEye, faPizzaSlice)

class OrdersList extends Component {

    renderStatus(order) {
        switch (order.status.toLowerCase()) {
            case 'delivering':
                return <FontAwesomeIcon icon='motorcycle' data-testid="delivering" />
            case 'ready':
                return <FontAwesomeIcon icon='pizza-slice' data-testid="ready" />
            case 'assigned':
                return <img src={PizzaIcon} className="custom-order__status-icon" alt="assigned" />
            case 'created':
                return <img src={ChefIcon} className="custom-order__status-icon" alt="created" />
            default:
                return <FontAwesomeIcon icon='eye' data-testid="eye" />
        }
    }

    isOrderSelectedOrDriverHasOrders(order) {

        const { orders, drivers } = this.props;
        const currentOrderState = {
            active: 'active',
            selected: 'selected'
        }

        let isOrderSelected = (orders.order.selected && orders.order.selected.id === order.id);
        let isActiveDriverHasOrders = (drivers.driver.highlighted && drivers.driver.highlighted.id === order.driverId);
        if (isOrderSelected) {
            return currentOrderState.active;
        }
        if (isActiveDriverHasOrders) {
            return currentOrderState.selected;
        }
        return '';
    }

    isOrderSelected(order) {
        const { orders } = this.props;
        let result = (orders.order.selected && orders.order.selected.id === order.id);
        return result;
    }

    render() {

        const { orders } = this.props;

        if (!orders || (orders.orders.length && orders.orders.length === 0)) {
            return null;
        }

        return (
            <>
                <div className="orders-list__wrapper">
                    <div className="orders-list__header">
                        <span>{i18n_get_value(I18N_LABELS.SIDEBAR_ORDERS_DELIVERY_LABEL)}</span>
                        <span className="orders-list__header-count">{orders.orders.length}</span>
                    </div>
                    <div className="orders-list">{
                        orders.orders.map(order => {

                            return (
                                <div
                                    key={order.id}
                                    id={order.id}
                                    data-testid="order-list"
                                    className={`orders-list__item ${this.isOrderSelectedOrDriverHasOrders(order)}`}
                                    onClick={() => this.updateSelectedOrder(order)}
                                    onMouseEnter={() => {
                                        const distTop = document.getElementById(order.id).offsetTop - document.getElementsByClassName('orders-list')[0].scrollTop;
                                        return (
                                            this.props.updateActiveDeliveryOrder(order, distTop)
                                        )
                                    }}
                                    onMouseLeave={() => this.props.clearActiveDeliveryOrder()}
                                >
                                    <div className="orders-list__info">
                                        <div className="orders-list__item-address">{order.address}</div>
                                        <div className="orders-list__item-timer">{time.renderDeliveryDateTimer(order)} </div>
                                        <div className="orders-list__item-action">{this.renderStatus(order)}</div>
                                    </div>

                                </div>
                            )
                        })
                    }</div>
                </div>
            </>
        );
    }


    updateSelectedOrder(order) {
        if (this.isOrderSelected(order)) {
            this.props.clearSelectedOrder()
            //   this.props.updateSelectedOrder(null);
        } else {
            this.props.updateSelectedOrder(order);
        }
    }


}

const mapDispatchToProps = {
    updateSelectedOrder,
    updateActiveDeliveryOrder,
    clearActiveDeliveryOrder,
    clearSelectedOrder
}

export default connect(null, mapDispatchToProps)(OrdersList);
